module.exports = __webpack_public_path__ + "media/images/icons/linkedin_rounded_square-9cbd58f42d4c3b520b8767925ef15a7b.png";